import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NewsViewComponent } from '@common/containers/news-view/news-view.component';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, take } from 'rxjs';

import { ModalService } from './modal.service';
import { ToastService } from './toast.service';

@Injectable({
    providedIn: 'root',
})
export class NewsService {
    API_URL = environment.API_URL;
    hideModal: boolean = false;
    hideMessage: boolean = false;
    loader$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    private _dataNews$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private _listNews$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

    constructor(private readonly http: HttpClient, private readonly toastService: ToastService, private readonly modalService: ModalService) {}

    get dataNews$(): Observable<any> {
        return this._dataNews$.asObservable();
    }

    set dataNews(data: any) {
        this._dataNews$.next({ ...data });
    }

    get listNews$(): Observable<any> {
        return this._listNews$.asObservable();
    }

    set listNews(data: any[]) {
        this._listNews$.next([...data]);
    }

    loadNews() {
        this.getLatestNews$()
            .pipe(take(1))
            .subscribe({
                next: (res: any) => {
                    if (res?.data) {
                        this.dataNews = { ...res.data };
                        this.modalService.open(NewsViewComponent, null);
                    }
                },
                error: error => {
                    this.toastService.error('Error', 'No se pudo cargar el modal con la noticia reciente');
                    console.error('Failed to load news:', error);
                },
            });
    }

    loadRecentNews() {
        this.loader$.next(true);
        this.getRecentNews$()
            .pipe(take(1))
            .subscribe({
                next: (res: any) => {
                    if (res?.data?.length > 0) this.listNews = [...res.data];
                    this.loader$.next(false);
                },
                error: error => {
                    this.toastService.error('Error', 'No se pudo cargar la información con las noticias recientes');
                    console.error('Failed to load recent news:', error);
                    this.loader$.next(false);
                },
            });
    }

    showModal(newObject: any) {
        this.hideMessage = true;
        this.dataNews = { ...newObject };
        this.modalService.open(NewsViewComponent, null);
    }

    onHideModal() {
        if (this.hideModal) {
            this.hideLatestNews$().subscribe({
                next: () => {
                    this.hideModal = false;
                },
                error: err => {
                    this.toastService.error(err.error.title, err.error.message);
                },
            });
        }
        setTimeout(() => {
            this.hideMessage = false;
        }, 200);
    }

    getLatestNews$(): Observable<any> {
        return this.http.get<any>(`${this.API_URL}/news/latest-news`);
    }

    private getRecentNews$(): Observable<any> {
        return this.http.get<any>(`${this.API_URL}/news/recent-news`);
    }

    private hideLatestNews$(): Observable<any> {
        return this.http.post<any>(`${this.API_URL}/news/hide-latest-news`, {});
    }
}
